import React from 'react'
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormROValue from '../../../../library/form/components/FormROValue1';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const BomCMNItemEditor = (props) => {
    const { formObject } = props;

    return (
        <>
            <li>
                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "actualItem" }} className='uiSpacerH10' />
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "nickName" }} />
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "estQty1" }} value="Quantity 1" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "estQty1" }} />
                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit1" }} className='uiSpacerH10' />
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "estQty2" }} value="Quantity 2" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiInput"
                    action={{ InputType: "input", paramName: "estQty2" }} />
                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit2" }} className='uiSpacerH10' />
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unitCost" }} value="Manual Cost" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "unitCost" }} />
                <span> /</span>
                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit1" }}/>
            </li>
            <li>
                <span><SarasTrans value = "System will use Standard cost of item when Manual Cost is 0"/></span>
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lossAllowed" }} value="Loss Allowed" />
                </span>
                <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "lossAllowed" }} />
                <span>%</span>
            </li>
            <li>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Details" />
                </span>
                <FormRichText formObject={formObject} rowKey="" className="uiFrmText" rows="3" cols="82"
                    action={{ paramName: "comment" }}
                />
            </li>
        </>
    )
}

export default BomCMNItemEditor;
